export default __webpack_public_path__ + "static/media/touchpointSVGNew.299d64ff.svg";